
import { Vue } from "vue-class-component";

export default class CleamTemplate extends Vue {}
